










































































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {deleteDraft, listDraft} from "@/modules/ladings/services";
import {AuthStore} from "@/modules/auth/store";
import {toSlug} from "@/shared/services/helper/utils";

const columns = [
    {
        title: "#",
        dataIndex: "id",
        key: "id",
        scopedSlots: {customRender: 'action'},
        fixed: 'left',
        width: 100
    },
    {
        title: "Mã đơn hàng",
        dataIndex: "ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: "ladingCode"}
    },
    {
        title: "Đại diện gửi",
        dataIndex: "locationFrom.name",
        key: "locationFromId",
        width: 200,
        ellipsis: true,
        scopedSlots: {customRender: "locationFromName"}

    },
    {
        title: "Tỉnh đến",
        dataIndex: "locationTo.province.name",
        key: "locationToId",
        width: 200,
        ellipsis: true,
        scopedSlots: {customRender: "provinceToName"}
    },
    {
        title: "Người nhận",
        dataIndex: "locationTo.name",
        key: "locationToName",
        width: 200,
        ellipsis: true,
        scopedSlots: {customRender: "locationToName"}
    },
    {
        title: "SDT Người nhận",
        dataIndex: "locationTo.phoneNumber",
        key: "locationToPhoneNumber",
        width: 120,
        ellipsis: true,
        scopedSlots: {customRender: "locationToPhoneNumber"}
    },
    {
        title: "Địa chỉ",
        dataIndex: "locationTo",
        key: "locationToAddress",
        scopedSlots: {customRender: "locationToAddress"},
        width: 500,
        ellipsis: true
    },
    {
        title: "Hàng hóa",
        dataIndex: "boxContent",
        key: "boxContent",
        width: 100,
        scopedSlots: {customRender: "boxContent"},
        ellipsis: true
    },
    {
        title: "Dịch vụ",
        dataIndex: "freightService.serviceCode",
        key: "freightService",
        width: 100,
        scopedSlots: {customRender: "freightService"},
        ellipsis: true
    },
    {
        title: "Tổng cước",
        dataIndex: "totalFee",
        key: "totalFee",
        scopedSlots: {customRender: "totalFee"},
        width: 150,
        ellipsis: true
    },
    {
        title: "Thu hộ",
        dataIndex: "codMoney",
        key: "codMoney",
        scopedSlots: {customRender: "codMoney"},
        width: 150,
        ellipsis: true
    },
    {
        title: "Thu tiền NN",
        dataIndex: "receiverCollect",
        key: "receiverCollect",
        scopedSlots: {customRender: "receiverCollect"},
        width: 150,
        ellipsis: true
    },
];
@Component({
    name: "LadingListDraft",
    components: {TooltipLabel}
})
export default class extends mixins(CommonMixin){
    columns = [...columns];
    ladings = [] as any;
    search = "";

    async created() {
        this.ladings = listDraft(AuthStore.user?.username);
    }

    deleteLading(id: any) {
        this.ladings = [...deleteDraft(id, AuthStore.user?.username)];
    }

    @Watch('search')
    onChangeSearch(val: any) {
        if (!val) {
            this.ladings = listDraft(AuthStore.user?.username);
            return;
        }
        this.ladings = this.ladings.filter((lading: any) => {
            return (
                (toSlug(lading.locationTo?.name, " ").toLowerCase().indexOf(toSlug(val, " ").toLowerCase()) >= 0) ||
                (toSlug(lading.locationTo?.phoneNumber, " ").toLowerCase().indexOf(toSlug(val, " ").toLowerCase()) >= 0)
            )
        })
    }
}
